<!-- Sidebar -->
<edp-e-sidebar
    *ngIf="!isApp"
    [open]="showSidebar"
    [hideSubMenu]="hideSubMenu"
    [ngClass]="{ 'd-lg-none': hideMenuAndHeader }"
></edp-e-sidebar>
<!-- End of Sidebar -->

<!-- Overlay component -->
<edp-overlay (displayLoader)="displayLoader($event)"></edp-overlay>
<!-- End overlay component -->

<!-- Menus for APP-->
<ng-container *ngIf="isApp">
    <!-- Topbar-->
    <div class="d-block d-lg-none top-menu-container" *ngIf="!hideTopMenuContainer">
        <ng-container *ngIf="!!showAlert">
            <edp-alert class="d-block w-100"></edp-alert>
        </ng-container>
        <div *edpConditionalRegion="'pt.edp.edponline.contract.consumption.local.pt'">
            <edp-contract-consumption-local class="d-lg-none"></edp-contract-consumption-local>
        </div>
        <div *edpConditionalRegion="'pt.edp.edponline.contract.consumption.local.es'">
            <edp-es-contract-consumption-local class="d-lg-none"></edp-es-contract-consumption-local>
        </div>
        <edp-e-menu-swipe class="d-lg-none" *ngIf="!hideSubMenu"></edp-e-menu-swipe>
    </div>
    <!-- End Topbar-->

    <!-- Bottombar-->
    <edp-e-menu-app class="d-lg-none"></edp-e-menu-app>
    <!-- End of Bottombar-->
</ng-container>
<!-- End Menus for APP-->

<!-- Main Content -->
<div
    class="main-content"
    [ngClass]="{
        'menu-hided': hideMenuAndHeader,
        'main-content-app': isApp,
        'hide-submenu': hideSubMenu,
        'has-app-banner': showAppBanner
    }"
>
    <ng-container *ngIf="!isApp">
        <!-- Topbar -->
        <edp-header [ngClass]="{ 'd-lg-none': hideMenuAndHeader }"></edp-header>
        <!-- End of Topbar -->
    </ng-container>

    <!-- Begin Page Content -->
    <re-captcha *ngIf="showCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
    <div [ngClass]="{ content: !hideSubMenu, 'h-100': hideSubMenu, 'p-0': removeHeaderPadding }">
        <div class="p-0 container-fluid" [hidden]="showIframe" [ngClass]="{ 'h-100': hideSubMenu }">
            <ng-container *ngIf="!unavailability; else unavailabilityTemplate">
                <router-outlet></router-outlet>
            </ng-container>
        </div>
        <div class="p-0 container-fluid" [hidden]="!showIframe">
            <edp-iframe></edp-iframe>
        </div>
    </div>
    <!-- End of Begin Page Content -->
    <!--FOOTER-->
    <edp-footer *ngIf="!isApp" class="flex-shrink-0" [ngClass]="{ 'd-none': hideMenuAndHeader }"></edp-footer>
</div>
<!--End of Main Content -->

<edp-loader *ngIf="showLoader" [position]="'full'"></edp-loader>

<edp-define-house-terms-conditions *ngIf="showTermsAndConditions"></edp-define-house-terms-conditions>

<ng-template #unavailabilityTemplate>
    <edp-unavailability></edp-unavailability>
</ng-template>
